import React from "react";

// components
import VideoPlayer from "@/components/VideoPlayer";
import ScrollDown from "@/components/ScrollDown";
import LoliveSearchBar from "./LoliveSearchBar";

// assets
import styles from "@/assets/styles/pages/lolive/lolive-page-banner.module.scss";

interface LoliveBannerProps {
  onScroll?: () => void;
  src?: string;
}

function LoliveBanner({ onScroll, src }: LoliveBannerProps) {

  return (
    <section className={styles["locl-lolive-page-banner"]}>
      <div className={styles["locl-lolive-page-banner__content"]}>
        <div className={styles["locl-lolive-page-banner__content__heading"]}>
          <h1 className={styles["locl-lolive-page-banner__content__title"]}>
            The global marketplace for live media space
          </h1>
          <h3 className={styles["locl-lolive-page-banner__content__subtitle"]}>
            The perfect activation space is just a few clicks away
          </h3>
        </div>
        <LoliveSearchBar/>
      </div>
      <VideoPlayer src={src || "https://d2gfhx6otln0v7.cloudfront.net/media/images/landing_lolive_v2_13_10_23.mp4"} />
      {
        onScroll && (
          <ScrollDown
            href="#"
            label="See more"
            className={styles["locl-lolive-page-banner__scroll-down"]}
            onScroll={onScroll}
          />
        )
      }
    </section>
  );
}

export default LoliveBanner;
